module.exports = __webpack_public_path__ + "static/img/m01.c22d88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c9/mobile/m01.png
// module id = a7Ws
// module chunks = 0